import { Navigate } from 'react-router-dom';

export default function ExpPage() {
  return <Navigate to="/year" replace />;
}
